// src/data/products.js

export const products = [
  {
    id: 1,
    name: "Standard Gabion Basket",
    size: "50cm × 50cm × 50cm",
    specs: "4.0mm Galfan Coated • Ideal for small garden features, decorative walls, and low borders",
    price: 90,
    image: "/images/gabion-size-4.jpg",
    alt: "50cm x 50cm x 50cm Galfan-coated gabion basket for small garden features and decorative walls",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 2,
    name: "Compact Gabion Basket",
    size: "100cm × 30cm × 30cm",
    specs: "4.0mm Galfan Coated • Perfect for garden edging, borders, and low landscape features",
    price: 100,
    image: "/images/gabion-size-5.jpg",
    alt: "100cm x 30cm x 30cm compact gabion basket ideal for garden borders and edging",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 3,
    name: "Large Retaining Basket",
    size: "100cm × 50cm × 30cm",
    specs: "4.0mm Galfan Coated • Great for low retaining walls and terraced gardens",
    price: 110,
    image: "/images/gabion-size-6.jpg",
    alt: "100cm x 50cm x 30cm large gabion basket for low retaining walls and terraced gardens",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 4,
    name: "Extra Large Basket",
    size: "100cm × 50cm × 50cm",
    specs: "4.0mm Galfan Coated • Versatile choice for medium retaining walls and garden structures",
    price: 130,
    image: "/images/gabion-size-7.jpg",
    alt: "100cm x 50cm x 50cm extra large gabion basket for medium retaining walls and garden structures",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 5,
    name: "Heavy Duty Retaining Basket",
    size: "100cm × 100cm × 50cm",
    specs: "4.0mm Galfan Coated • Best for taller retaining walls and commercial projects",
    price: 175,
    image: "/images/gabion-size-8.jpg",
    alt: "100cm x 100cm x 50cm heavy duty gabion basket for taller retaining walls and commercial projects",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  },
  {
    id: 6,
    name: "Long Gabion Panel",
    size: "100cm × 100cm × 100cm",
    specs: "4.0mm Galfan Coated • Ideal for structural retaining walls and large-scale installations",
    price: 200,
    image: "/images/gabion-size-300.jpg",
    alt: "100cm x 100cm x 100cm gabion panel for structural retaining walls and large installations",
    category: "Baskets",
    available: true,
    coating: "Galfan",
    wire: "4.0mm"
  }
];